import React from 'react';
import { Link } from 'react-router-dom';
import {
  HiSearch, HiChat, HiVideoCamera,
  HiShieldCheck, HiBan, HiLockClosed, HiBadgeCheck,
  HiArrowRight,
} from 'react-icons/hi';
import './Landing.css';

const Landing = () => {
  const steps = [
    {
      icon: HiSearch,
      title: 'Create your profile',
      text: 'Sign up in under a minute and set your preferences. You decide what you share and who sees it.',
    },
    {
      icon: HiChat,
      title: 'Discover & chat',
      text: 'Browse real people near you and start a conversation. Messaging is free, no catch.',
    },
    {
      icon: HiVideoCamera,
      title: 'Connect on your terms',
      text: 'Video call straight from the chat when you are both ready. You stay in control the whole way.',
    },
  ];

  const trust = [
    {
      icon: HiBadgeCheck,
      title: 'Profile verification',
      text: 'Members can get verified so you know you are talking to a real person.',
    },
    {
      icon: HiBan,
      title: 'Block & report anytime',
      text: 'One tap to block or report. We review every report, usually within 24 hours.',
    },
    {
      icon: HiLockClosed,
      title: 'Private & secure',
      text: 'Your data is encrypted in transit and handled in line with POPIA. You can delete your account anytime.',
    },
    {
      icon: HiShieldCheck,
      title: 'Strictly 18+',
      text: 'Age-gated and adults-only. We take safety and consent seriously.',
    },
  ];

  return (
    <div className="landing">
      {/* Navigation */}
      <nav className="landing-nav">
        <div className="nav-content">
          <Link to="/" className="nav-logo">
            <span className="logo-text">KwikLuv</span>
          </Link>
          <div className="nav-links">
            <Link to="/faq" className="nav-link">How it works</Link>
            <Link to="/about" className="nav-link">Safety</Link>
            <Link to="/login" className="nav-link nav-link-signin">Sign In</Link>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <header className="hero-section">
        <div className="hero-bg" aria-hidden="true">
          <div className="hero-glow hero-glow-1" />
          <div className="hero-glow hero-glow-2" />
        </div>

        <div className="hero-content">
          <span className="hero-eyebrow">18+ dating &amp; connections</span>
          <h1 className="hero-title">
            Real connections,<br />on your terms.
          </h1>
          <p className="hero-subtitle">
            KwikLuv is a private, adults-only space to meet people nearby, chat freely,
            and connect when it feels right. No games, no pressure.
          </p>

          <div className="hero-buttons">
            <Link to="/register" className="hero-btn primary">
              Create free account <HiArrowRight aria-hidden="true" />
            </Link>
            <Link to="/login" className="hero-btn secondary">
              Sign in
            </Link>
          </div>

          <p className="hero-microcopy">
            Free to join. No credit card required. Cancel anytime.
          </p>
        </div>
      </header>

      {/* How it works */}
      <section className="section how-section">
        <div className="section-inner">
          <div className="section-head">
            <h2 className="section-title">How KwikLuv works</h2>
            <p className="section-sub">Three simple steps, and you are always in control.</p>
          </div>
          <div className="steps-grid">
            {steps.map((s, i) => (
              <div className="step-card" key={s.title}>
                <div className="step-number">{i + 1}</div>
                <div className="step-icon" aria-hidden="true">{React.createElement(s.icon)}</div>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Safety & trust */}
      <section className="section trust-section">
        <div className="section-inner">
          <div className="section-head">
            <h2 className="section-title">Built with safety in mind</h2>
            <p className="section-sub">
              An adult platform only works when people feel safe. Here is how we protect you.
            </p>
          </div>
          <div className="trust-grid">
            {trust.map((t) => (
              <div className="trust-card" key={t.title}>
                <div className="trust-icon" aria-hidden="true">{React.createElement(t.icon)}</div>
                <div>
                  <h3>{t.title}</h3>
                  <p>{t.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>Ready when you are</h2>
          <p>Join a community built on real people and genuine connection.</p>
          <Link to="/register" className="cta-button">
            Get started, it is free
          </Link>
          <p className="cta-legal">You must be 18 or older to join. Adult content.</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-section footer-brand">
            <h3>KwikLuv</h3>
            <p>Real connections, on your terms.</p>
          </div>

          <div className="footer-section">
            <h4>Company</h4>
            <Link to="/about">About Us</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/faq">FAQ</Link>
          </div>

          <div className="footer-section">
            <h4>Legal</h4>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/privacy">Privacy Policy</Link>
          </div>

          <div className="footer-section">
            <h4>Support</h4>
            <a href="mailto:support@kwikluv.com">support@kwikluv.com</a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>18+ only. KwikLuv contains adult content intended for mature audiences.</p>
          <p>&copy; 2026 KwikLuv. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Landing;
